module.exports = __webpack_public_path__ + "img/1493821980.cec0e546.jpg";